import { iatan2, withinRange } from '../math/fixed.ts';
import type { BattleState, Enemy, GuardRules, SendaNpc } from '../types.ts';
import { damageEnemy, ev } from './combat.ts';
import { stepToward } from './enemies.ts';

/**
 * A path's person who fights where it keeps (Ser Marit, the paladin's path; Dalmo by the mule is the warrior's own):
 * what comes within `guard` of its spot it goes at, slowly, and strikes every `every` within `reach`; with nothing
 * near, back to its spot. A blow on it (SENDA.npc.flinch) stops it a moment. Returns the tick of its next blow.
 *
 * Cost: one look at the nightmares a tick for the one person (docs/RENDIMIENTO.md, «Reglas para lo nuevo»).
 */
export const guardTick = (s: BattleState, n: SendaNpc, home: { x: number; y: number }, g: GuardRules, swing: number, skip?: (e: Enemy) => boolean): number => {
  n.moving = false;
  if (n.hp <= 0) return swing;
  if (n.flinch > 0) {
    n.flinch--;
    return swing;
  }
  let best: Enemy | null = null;
  let bd = 0x7fffffff;
  for (const e of s.enemies) {
    if (e.hp <= 0 || (skip && skip(e))) continue;
    if (!withinRange(e.x, e.y, home.x, home.y, g.guard)) continue;
    const d = Math.abs(e.x - n.x) + Math.abs(e.y - n.y);
    if (d < bd) {
      bd = d;
      best = e;
    }
  }
  if (best) {
    if (!withinRange(best.x, best.y, n.x, n.y, g.reach)) {
      n.moving = true;
      stepToward(n, best.x, best.y, g.speed);
      return swing;
    }
    if (best.x !== n.x || best.y !== n.y) n.facing = iatan2(best.y - n.y, best.x - n.x);
    if (s.tick >= swing) {
      damageEnemy(s, best, g.hit, { pid: '' });
      ev(s, { t: 'senda', kind: 'work', npc: n.id, x: best.x, y: best.y });
      return s.tick + g.every;
    }
    return swing;
  }
  if (!withinRange(n.x, n.y, home.x, home.y, 200)) {
    n.moving = true;
    stepToward(n, home.x, home.y, g.speed);
  }
  return swing;
};
